export default function (value) {
  return JSON.stringify(value, null, 2);
}
